import Constants from "expo-constants";
import { Platform } from "react-native";
import { LOCAL_HUB_BASE_URL, PROD_HUB_BASE_URL } from "./hub-url";

export const isStaging = false;
export const isDev = process.env.EXPO_PUBLIC_IS_DEV === "true";
export const stagingBaseUrl = "https://staging-partners.memorang.app";

const hostPath = Constants.expoConfig?.hostUri?.split(":").shift();

const localHubDefault =
	Platform.OS === "android"
		? `http://${hostPath}:3000`
		: isStaging
			? PROD_HUB_BASE_URL
			: LOCAL_HUB_BASE_URL;

export const baseNextjsUrl = isDev ? localHubDefault : PROD_HUB_BASE_URL;

export const baseDevUrl =
	Platform.OS === "android"
		? `http://${hostPath}:8081`
		: isStaging
			? "https://staging-partners.memorang.app"
			: "http://localhost:8081";

export const ENDPOINT_GET_WAVEFORM_DATA = `${baseNextjsUrl}/api/v2/ai/get-audio-waveform`;

export const ENDPOINT_TTS = `${baseNextjsUrl}/api/v2/ai/tts`;

export const ENDPOINT_APP_CONFIG = `${baseNextjsUrl}/api/app-config`;
